'use client';

import React from 'react';

export default function VariantTabs({ variants, activeVariantId, onSelect }) {
  if (!variants || variants.length === 0) return null;

  return (
    <div className="flex justify-center w-full mb-8">
      <div className="inline-flex items-center p-1 bg-[#F1F1F4] rounded-small-button-mob md:rounded-small-button-desk">
        {variants.map((variant) => {
          const isActive = variant.id === activeVariantId;
          return (
            <button
              key={variant.id}
              onClick={() => onSelect(variant.id)}
              className={`px-6 py-2 rounded-small-button-mob md:rounded-small-button-desk text-sm font-semibold transition-all duration-300 ${isActive
                  ? 'bg-[#CFD0D6] text-gray-900 shadow-sm'
                  : 'text-gray-500 hover:text-gray-700'
                }`}
            >
              {variant.english_name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
